var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"razar",class:_vm.monitoring ? '' : 'paused'},[_c('div',{staticClass:"ringbase ring1"}),_vm._v(" "),_c('div',{staticClass:"ringbase ring2"}),_vm._v(" "),_c('div',{staticClass:"pulse"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"dot pos1"}),_vm._v(" "),_c('div',{staticClass:"dot pos2"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pointer"},[_c('div')])
}]

export { render, staticRenderFns }